var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$options.name}},[_c('v-row',{staticClass:"mt-n4"},[_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12"}},[_c('a-rms-year-sales',{ref:"a-rms-year-sales",attrs:{"tab_view":_vm.tab_view}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }